

export const getToken = () => localStorage.getItem("TOKEN");
export const getRToken = () => localStorage.getItem("RTOKEN");
export const getProfile = () => localStorage.getItem("PROFILE");

export const setToken = (value: string) => localStorage.setItem("TOKEN", value);


export const getUrl = async () => {
  const response = await fetch("/resources/config.json");
  const results = await response.json();
  return results;
}


export const logout = (): void => {
  localStorage.removeItem("TOKEN");
  localStorage.removeItem("RTOKEN");
  localStorage.removeItem("PROFILE");
  window.location.reload()
};
interface YearOption {
  value: string;
  name: string;
}
export const getYearOptions = (startYear = 2566): YearOption[] => {
  const currentYear = new Date().getFullYear() + 543; // แปลง ค.ศ. → พ.ศ.

  return Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
    const year = String(currentYear - i);
    return { value: year, name: year };
  });
};